import { AmplitudeEventCreator } from 'analytics/AmplitudeEventCreator';
import { AmplitudeEvents } from 'analytics/AmplitudeEvents';

// istanbul ignore next
function trackReminderEmailSent(result, eventProperties) {
  AmplitudeEventCreator.getInstance().createEvent(AmplitudeEvents.reminderEmailSent, {
    country: eventProperties?.country,
    label: eventProperties?.reminderLabel,
    ...eventProperties,
  });
}

function trackValidateActualEmailSent(eventProperties) {
  AmplitudeEventCreator.getInstance().createEvent(AmplitudeEvents.validateActuals, {
    country: eventProperties?.country,
    ...eventProperties,
  });
}

function trackManualActualUpload(eventProperties) {
  AmplitudeEventCreator.getInstance().createEvent(AmplitudeEvents.manualActualUpload, {
    country: eventProperties?.country,
    ...eventProperties,
  });
}

function trackManualCommittedUpload(eventProperties) {
  AmplitudeEventCreator.getInstance().createEvent(AmplitudeEvents.manualCommittedUpload, {
    country: eventProperties?.country,
    ...eventProperties,
  });
}

// Fired when a user lands on the app via a notification email's link, which
// the backend tags with ?action_name=<email-service-name> (see
// template.service.ts). Identifies which email drove the click.
function trackEmailLinkClicked(actionName: string) {
  AmplitudeEventCreator.getInstance().createEvent(AmplitudeEvents.emailLinkClicked, {
    action_name: actionName,
  });
}

export const TrackEmailEvents = {
  trackReminderEmailSent,
  trackValidateActualEmailSent,
  trackManualActualUpload,
  trackManualCommittedUpload,
  trackEmailLinkClicked,
};
